<template>
    <main>
        <div v-if="!show">
                <v-text-field
                    :rules="emailRules"
                    v-model="email"
                    label="E-post"
                    outlined
                    @change="submit"
                />
                <!-- <v-btn @click="submit" color="warning">Nästa</v-btn> -->
                <sociallogin />
        </div>
        <div v-if="show">
            <div v-if="login">
                <login ref="reg" v-bind:createmeeting="true" 
                :title="title" 
                :description="description" 
                :location="location" 
                :theme="theme" 
                :customtheme="customtheme" />
            </div>
            <div v-else>
                <register ref="reg" v-bind:createmeeting="true" 
                :title="title" 
                :description="description" 
                :location="location" 
                :theme="theme" 
                :customtheme="customtheme"
                />
            </div>
        </div>
    </main>
</template>

<script>
import login from "./Loginhome";
import register from "./Registerhome";
import sociallogin from "./sociallogin";
import store from "../../store";
import axios from "axios";
export default {
    data: function() {
        return {
            email: "",
            store: store,
            show: false,
            awaitingSearch: false,
            login: null,
            emailRules: [
                v => !!v || "Din mail krävs",
                v => /.+@.+\..+/.test(v) || "Email måste vara giltig"
            ]
        };
    },
    props: ["title",'description','location','theme','customtheme'],
    components: {
        sociallogin,
        login,
        register
    },
    watch: {
      email: function () {
        if (!this.awaitingSearch) {
          setTimeout(() => {
        this.submit()
            this.awaitingSearch = false;
          }, 8000); // 1 sec delay
        }
        this.awaitingSearch = true;
      },
    },
    methods: {
        submit: async function() {
            let bodyForm = new FormData();
            bodyForm.set("email", this.email);
            this.store.dispatch("setEmail", this.email);
            const config = {
                method: "post",
                url: `${this.store.state.baseURL}findacc`,
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyForm
            };
            let resp = await axios(config);

            this.login = resp.data;
            this.show = true;
        },

        done() {
            this.$refs.reg.submit();
        }
    }
};
</script>

<style></style>
